<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage['SMB']['GLCBA']}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <customtreeselect :multiple="true"
                                            :limit="1"
                                            :load-options="loadAgentOptions"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :options="ddAgentList"
                                            :defaultExpandLevel="Infinity"
                                            :auto-load-root-options="convertToBool(searchAgent)"
                                            :disable-branch-nodes="false"
                                            @input="selectAgentOptions"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            :limitText="count => `+${count}`"
                                            v-model="searchAgent" />
                                <span class="ErrMsg">{{ ValidationErrMsg('AGT') }}</span>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GAME']['CAT']}}</span>
                                <treeselect :multiple="false"
                                            :load-options="loadCategoryOptions"
                                            :options="ddCategoryList"
                                            :placeholder="this.utilGetDDLanguage('GAME.CAT')"
                                            :auto-load-root-options="false"
                                            @input="CategoryNameChange"
                                            v-model="searchCategory" />
                                <span class="ErrMsg"></span>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GAME']['PROV']}}</span>
                                <treeselect :multiple="false"
                                            :options="ddProviderList"
                                            :placeholder="this.utilGetDDLanguage('GAME.PROV')"
                                            :auto-load-root-options="false"
                                            :load-options="loadProviderOptions"
                                            v-model="searchProvider" />
                                <span class="ErrMsg"></span>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage['SMB']['GLCBA']}}</strong>
                    <div>
                        <CButton v-if="arr_GameList && arr_GameList.length != 0 && this.searchAgent!= null && this.searchAgent.length != 0 && checkModuleAccess2(constAccessType.edit)" class='searchBtn' size="sm" color="info" @click="SaveConfig()"><span>{{this.getLanguage["BTN"]["SV"]}}</span></CButton>
                        <div class="pageBtn">
                            <button @click="ctrPage(+int_Page - 1)">
                                <span class="arrowLeft"></span>
                            </button>
                            <input class="page-control"
                                   v-model="int_Page"
                                   type="number"
                                   v-shortkey.avoid
                                   @keyup="ctrPage(+int_Page,0)" />
                            <span class="tableItemCount">/ {{int_TP}}</span>
                            <button @click="ctrPage(+int_Page + 1)">
                                <span class="arrowRight"></span>
                            </button>
                        </div>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th class="width80">{{this.getLanguage['GL']['ID']}}</th>
                                <th>{{this.getLanguage['GAME']['PROV']}} <i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['GAME']['CAT']}} <i @click="setSortTable('CN')" :class="setSortLogo('CN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['GAME']['NM']}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.view)">{{this.getLanguage['GAME']['RS']}}<span class="float-right"><input type="checkbox" v-model="selectStatus" class="checkBox15" /></span></th>
                                <th v-if="checkModuleAccess2(constAccessType.view)">{{this.getLanguage['GAME']['NEW']}}<span class="float-right"><input type="checkbox" v-model="selectNew" class="checkBox15" /></span></th>
                                <th v-if="checkModuleAccess2(constAccessType.view)">{{this.getLanguage['GAME']['HOT']}}<span class="float-right"><input type="checkbox" v-model="selectHot" class="checkBox15" /></span></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th class="width80">{{this.getLanguage['GL']['ID']}}</th>
                                <th>{{this.getLanguage['GAME']['PROV']}} <i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['GAME']['CAT']}} <i @click="setSortTable('CN')" :class="setSortLogo('CN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['GAME']['NM']}}</th>
                                <th class="width80" v-if="checkModuleAccess2(constAccessType.view)">{{this.getLanguage['GAME']['RS']}}<span class="float-right"><input type="checkbox" v-model="selectStatus" class="checkBox15" /></span></th>
                                <th class="width80" v-if="checkModuleAccess2(constAccessType.view)">{{this.getLanguage['GAME']['NEW']}}<span class="float-right"><input type="checkbox" v-model="selectNew" class="checkBox15" /></span></th>
                                <th class="width80" v-if="checkModuleAccess2(constAccessType.view)">{{this.getLanguage['GAME']['HOT']}}<span class="float-right"><input type="checkbox" v-model="selectHot" class="checkBox15" /></span></th>
                            </tr>
                        </thead>
                        <td colspan="100%" v-if="arr_GameList && arr_GameList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tbody v-for="(data,index) in arr_GameList">
                            <tr>
                                <td class="width80">
                                    <span v-if="data.AGI!=0" @click="toggle(data,index)" class="pointer">
                                        <span class="grid-line">
                                            <span class="custom_tooltip">
                                                {{ CountItem(index+1) }}
                                            </span>
                                            <span class="float-right">
                                                <span v-bind:id="'icon'+data.I" name="icon" class="searchIcon cil-plus"></span>
                                            </span>
                                        </span>
                                    </span>
                                    <span v-else class="grid-line">
                                        <span class="custom_tooltip">
                                            {{ CountItem(index+1) }}
                                        </span>
                                    </span>
                                </td>
                                <td>{{ renderProviderName(data.PN) }}</td>
                                <td>{{ renderCategory(data.GCI) }}</td>
                                <td>{{ renderGameName( data.PN, data.GN ) }}</td>
                                <td v-if="checkModuleAccess2(constAccessType.view)" class="checkBoxTD width80">
                                    <span class="chkPadding"><input class="checkBox15" true-value="2" false-value="1" v-model="data.RS" type="checkbox" :value="data.RS" number @change="v=>configChanged('RS',index)" /></span>
                                </td>
                                <td v-if="checkModuleAccess2(constAccessType.view)" class="checkBoxTD width80">
                                    <span class="text-center chkPadding"><input class="checkBox15" true-value="1" false-value="0" name="new" v-model="data.N" type="checkbox" :value="data.N" number @change="v=>configChanged('new',index)" /></span>
                                </td>
                                <td v-if="checkModuleAccess2(constAccessType.view)" class="checkBoxTD width80">
                                    <span class="text-center chkPadding"><input class="checkBox15" true-value="1" false-value="0" name="hot" v-model="data.H" type="checkbox" :value="data.H" number @change="v=>configChanged('hot',index)" /></span>
                                </td>
                            </tr>
                            <tr v-if="opened.includes(data.I)" v-for="(data2,index2) in arr_GameListChild[index]" v-bind:id="data.I" class="childClass">
                                <!--v-for="(data2,index) in arr_GameListChild[data.I]"-->
                                <!-- style="display:none" -->
                                <td colspan="4" align="right">{{ data2.AGN }} ({{ data2.APC }})</td>
                                <td class="checkBoxTD width80">
                                    <span class="chkPadding"><input class="checkBox12" true-value="1" false-value="0" v-model="data2.IE" type="checkbox" :value="data2.IE" number @change="v=>configChangedChild('RS',index,index2)" /></span>
                                </td>
                                <td class="checkBoxTD width80">
                                    <span class="text-center chkPadding"><input class="checkBox12" true-value="1" false-value="0" name="new" v-model="data2.N" type="checkbox" :value="data2.N" number @change="v=>configChangedChild('new',index,index2)" /></span><!--  -->
                                </td>
                                <td class="checkBoxTD width80">
                                    <span class="text-center chkPadding"><input class="checkBox12" true-value="1" false-value="0" name="hot" v-model="data2.H" type="checkbox" :value="data2.H" number @change="v=>configChangedChild('hot',index,index2)" /></span><!--  -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <footer class="d-flex justify-content-end py-2">
                    <CButton v-if="arr_GameList && arr_GameList.length != 0 && this.searchAgent!= null && this.searchAgent.length != 0 && checkModuleAccess2(constAccessType.edit)" class='searchBtn' size="sm" color="info" @click="SaveConfig()"><span>{{this.getLanguage["BTN"]["SV"]}}</span></CButton>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import { required } from "vuelidate/lib/validators";
    import { constAccessType, constStatus, loadingFullScreen } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                bool_CV: false, // Check Validation
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                str_FV: "", //Filter Value
                searchCategory: null,
                searchProvider: null,
                searchAgent: null,
                searchAgi: '',
                ddCategoryList: null,
                ddAgentList: null,
                ddProviderList: null,
                arr_GameList: [],
                arr_GameListChild: [[]],
                GameListChildPostData: [],
                changedConfigs: [],
                opened: [],
                constAccessType: constAccessType,
            }
        },
        methods: {
            SaveConfig() {

                this.bool_CV = true;
                var that = this;
                this.$v.searchAgent.$touch();
                if (!this.$v.searchAgent.$error) {
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    this.bool_CV = false;

                    var childLength = this.arr_GameListChild.length;
                    for (var i = 0; i < childLength; i++) {
                        if (Array.isArray(this.arr_GameListChild[i])) {
                            for (var j = 0; j < this.arr_GameListChild[i].length; j++) {

                                this.changedConfigs.push(this.arr_GameListChild[i][j]);
                            }
                        }
                    }

                    this.postDataApi(`/api/game/sglcba`, this.changedConfigs,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;

                            if (s) {
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                that.changedConfigs = [];
                            }
                            that.getGameList();
                        });
                }
            },

            AgentGroupChangefs(value) {
                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                    }
                    that.str_FV[0].FV = agi;
                }
                else {
                    this.str_FV[0].FV = null;
                }

            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('GLCBA', 'GS', type);
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getGameList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getGameList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getGameList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            ValidationErrMsg(langKey = "") {
                if (this.bool_CV) {
                    var validateObj = this.$v.searchAgent;
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["GL"][langKey]);
                    }
                }
            },
            getGameList() {

                this.bool_CV = true;
                var that = this;
                var hasDefaultPath = false;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (path) {
                    hasDefaultPath = true;
                }

                if (this.searchAgi) {
                    path += "&f.AGI_csv=" + this.searchAgi;
                }
                if (this.searchCategory) {
                    path += ("&f.GCI=" + this.searchCategory);
                }
                if (this.searchProvider) {
                    path += ("&f.GPI=" + this.searchProvider);
                }

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                if (document.getElementsByName("icon") != null) {
                    var icons = document.getElementsByName("icon");
                    for (var i = 0; i < icons.length; i++) {
                        icons[i].className = "searchIcon cil-plus";
                    }
                }

                this.$v.searchAgent.$touch();
                if (!this.$v.searchAgent.$error) {
                    this.bool_fullLoading = true;
                    this.bool_CV = false;
                    this.getDataApi(`/api/game/lbac?${path}`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.int_TP = Math.max(d.D.TotalPages, 1);
                                that.int_Total = d.D.TotalItems;

                                that.arr_GameListChild = [[]];
                                for (var i = 0; i < d.D.Items.length; i++) {
                                    if (d.D.Items[i].AGI != 0) {
                                        that.arr_GameListChild[i] = d.D.Items[i].I;//[];
                                    }
                                }
                                that.arr_GameList = d.D.Items;
                                that.opened = [];
                                that.resizeTableHead();
                            }
                        });

                }

            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        callback();
                    });
            },
            loadCategoryOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/gameCat`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderCategory(d.dropdownlist[i].id);
                            }
                            that.ddCategoryList = d.dropdownlist;
                        }
                        else {
                            that.ddCategoryList = null;
                        }

                        callback();
                    });
            },
            renderCategory(id) {
                return this.getLanguage["GC"][id];
            },
            getCategory() {
                for (var i = 0; i < this.ddCategoryList.length; i++) {
                    this.ddCategoryList[i].label = this.renderCategory(this.ddCategoryList[i].id);
                }
            },
            CategoryNameChange(value) {
                this.ddProviderList = null;
                this.searchProvider = null;

                if (value != undefined && value > 0) {
                    var that = this;

                    this.getDataApi(`/api/dd/gameProvByCatId/` + value,

                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                for (var i = 0; i < d.dropdownlist.length; i++) {
                                    d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label2);
                                }

                                that.ddProviderList = d.dropdownlist;
                            }
                            else {
                                that.ddProviderList = null;
                            }
                        });

                }

            },
            selectAgentOptions(value, instanceId) {
                var temp = "";
                var y = 0;
                for (var x = 0; x < value.length; x++) {
                    var split = value[x].split("-");
                    if (split[0] == "3") {  // search agent only AT=3
                        if (y != 0) {
                            temp += ",";
                        }
                        if (split.length == 2) {
                            temp += split[1];
                        }
                        else {
                            temp += split[0];
                        }
                        y++;
                    }
                }
                this.searchAgi = temp;
            },
            loadProviderOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/gameProv/`,

                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label2);
                            }

                            that.ddProviderList = d.dropdownlist;
                        }
                        else {
                            that.ddProviderList = null;
                        }

                        callback();
                    });
            },
            configChanged(name, index) {
                const config = this.arr_GameList[index];
                const changedConfig = this.changedConfigs.find((value) => value.I === config.I);

                if (!changedConfig) {
                    this.changedConfigs.push(config);
                }
                if (name === 'hot' && config.H === '1') {
                    config.N = 0;
                    if (config.AGI != 0) {
                        for (var i = 0; i < this.arr_GameListChild[index].length; i++) {
                            this.arr_GameListChild[index][i].N = 0;
                            this.arr_GameListChild[index][i].H = 1;

                        }
                    }
                }
                if (name === 'hot' && config.H === '0') {
                    if (config.AGI != 0) {
                        for (var i = 0; i < this.arr_GameListChild[index].length; i++) {
                            this.arr_GameListChild[index][i].H = 0;
                        }
                    }
                }

                if (name === 'new' && config.N === '1') {
                    config.H = 0;
                    if (config.AGI != 0) {
                        for (var i = 0; i < this.arr_GameListChild[index].length; i++) {
                            this.arr_GameListChild[index][i].H = 0;
                            this.arr_GameListChild[index][i].N = 1;
                        }
                    }
                }
                if (name === 'new' && config.N === '0') {
                    if (config.AGI != 0) {
                        for (var i = 0; i < this.arr_GameListChild[index].length; i++) {
                            this.arr_GameListChild[index][i].N = 0;
                        }
                    }
                }

                if (name === 'RS' && config.RS === '1') { // 1 or 2
                    if (config.AGI != 0) {
                        for (var i = 0; i < this.arr_GameListChild[index].length; i++) {
                            this.arr_GameListChild[index][i].IE = 0;
                        }
                    }
                }

                if (name === 'RS' && config.RS === '2') { // 1 or 2
                    if (config.AGI != 0) {
                        for (var i = 0; i < this.arr_GameListChild[index].length; i++) {
                            this.arr_GameListChild[index][i].IE = 1;
                        }
                    }
                }
            },
            configChangedChild(name, MainIndex, index) {
                var rowIndex = parseInt(MainIndex);
                const configChild = this.arr_GameListChild[rowIndex][index];

                if (name === 'hot' && configChild.H === '1') {
                    this.arr_GameListChild[rowIndex][index].N = 0;
                    var that = this;
                    that.opened.push(MainIndex);
                }
                if (name === 'new' && configChild.N === '1') {
                    this.arr_GameListChild[rowIndex][index].H = 0;
                    var that = this;
                    that.opened.push(MainIndex);
                }
            },
            toggle(data, MainIndex) {
                var that = this;

                const index = that.opened.indexOf(data.I);
                if (index > -1) {
                    document.getElementById('icon' + data.I).className = "searchIcon cil-plus";
                    that.opened.splice(index, 1);

                } else {
                    document.getElementById('icon' + data.I).className = "searchIcon cil-minus";
                    var obj_GameListChildPostData = {
                        "AGI_csv": this.searchAgi,
                        "GPI": this.searchProvider,
                        "GID": data.I,

                    };

                    this.postDataApi(`/api/game/lbacgid`, obj_GameListChildPostData,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.arr_GameListChild[MainIndex] = d;
                                that.opened.push(data.I);
                                if (d && d.length != 0) {
                                    for (var x = 0; x < d.length; x++) {
                                        that.removeAGI_csvFromMain(MainIndex, d[x].AGI);
                                    }
                                }
                            }
                        });
                }
            },
            removeAGI_csvFromMain(index, AGI) {
                var cvsArray = this.arr_GameList[index].AGI_csv.split(',');
                if (cvsArray && cvsArray.length != 0) {
                    var newString = "";
                    var y = 0;
                    for (var x = 0; x < cvsArray.length; x++) {
                        if (cvsArray[x] != AGI) {
                            if (y != 0) {
                                newString += ",";
                            }
                            newString += cvsArray[x];
                            y++;
                        }

                    }
                    this.arr_GameList[index].AGI_csv = newString;
                }
            },
            renderGameName(providerName, gameName) {
                if (providerName in this.getLanguage && gameName in this.getLanguage[providerName])
                    return this.getLanguage[providerName][gameName];
                else
                    return gameName;
            },
            renderAgentGroupName(AGN, APC) {
                return AGN + "(" + APC + ")";
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
        },
        validations: {
            searchAgent: { required }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess']),

            selectNew: {
                get: function () {
                    var NewTick = 0;
                    if (this.arr_GameList && this.arr_GameList != null) {
                        for (var i = 0; i < this.arr_GameList.length; i++) {
                            if (this.arr_GameList[i].N == 1) {
                                NewTick++;
                            }
                        }
                        return this.arr_GameList ? NewTick == this.arr_GameList.length : false;
                    }
                },
                set: function (value) {
                    if (value) {
                        for (var i = 0; i < this.arr_GameList.length; i++) {
                            if (this.arr_GameList[i].N == 0) {
                                this.configChanged('new', i);
                            }

                            this.arr_GameList[i].N = 1;
                            this.arr_GameList[i].H = 0;

                            if (this.arr_GameList[i].AGI != 0) {
                                for (var j = 0; j < this.arr_GameListChild[i].length; j++) {
                                    this.arr_GameListChild[i][j].H = 0;
                                    this.arr_GameListChild[i][j].N = 1;
                                }
                            }

                        }
                    }
                    else {
                        for (var i = 0; i < this.arr_GameList.length; i++) {

                            if (this.arr_GameList[i].N == 1) {
                                this.configChanged('new', i);
                            }

                            this.arr_GameList[i].N = 0;

                            if (this.arr_GameList[i].AGI != 0) {
                                for (var j = 0; j < this.arr_GameListChild[i].length; j++) {
                                    this.arr_GameListChild[i][j].N = 0;
                                }
                            }
                        }
                    }
                }
            },
            selectHot: {
                get: function () {
                    var HotTick = 0;
                    if (this.arr_GameList && this.arr_GameList != null) {
                        for (var i = 0; i < this.arr_GameList.length; i++) {
                            if (this.arr_GameList[i].H == 1) {
                                HotTick++;
                            }
                        }
                        return this.arr_GameList ? HotTick == this.arr_GameList.length : false;
                    }

                },
                set: function (value) {
                    if (value) {
                        for (var i = 0; i < this.arr_GameList.length; i++) {

                            if (this.arr_GameList[i].H == 0) {
                                this.configChanged('hot', i);
                            }

                            this.arr_GameList[i].H = 1;
                            this.arr_GameList[i].N = 0;

                            if (this.arr_GameList[i].AGI != 0) {
                                for (var j = 0; j < this.arr_GameListChild[i].length; j++) {
                                    this.arr_GameListChild[i][j].H = 1;
                                    this.arr_GameListChild[i][j].N = 0;
                                }
                            }
                        }
                    }
                    else {
                        for (var i = 0; i < this.arr_GameList.length; i++) {

                            if (this.arr_GameList[i].H == 1) {
                                this.configChanged('hot', i);
                            }

                            this.arr_GameList[i].H = 0;

                            if (this.arr_GameList[i].AGI != 0) {
                                for (var j = 0; j < this.arr_GameListChild[i].length; j++) {
                                    this.arr_GameListChild[i][j].H = 0;
                                }
                            }
                        }
                    }
                }
            },
            selectStatus: {
                get: function () {
                    var AllStatusTick = 0;
                    if (this.arr_GameList && this.arr_GameList != null) {
                        for (var i = 0; i < this.arr_GameList.length; i++) {
                            if (this.arr_GameList[i].RS == 2) {
                                AllStatusTick++;
                            }
                        }
                        return this.arr_GameList ? AllStatusTick == this.arr_GameList.length : false;
                    }
                },
                set: function (value) {
                    if (value) {
                        for (var i = 0; i < this.arr_GameList.length; i++) {
                            this.arr_GameList[i].RS = 2;
                            const config = this.arr_GameList[i];
                            const changedConfig = this.changedConfigs.find((value) => value.I === config.I);
                            if (!changedConfig) {
                                this.changedConfigs.push(config);
                            }
                        }
                    }
                    else {
                        for (var i = 0; i < this.arr_GameList.length; i++) {
                            this.arr_GameList[i].RS = 1;
                            const config = this.arr_GameList[i];
                            const changedConfig = this.changedConfigs.find((value) => value.I === config.I);
                            if (!changedConfig) {
                                this.changedConfigs.push(config);
                            }
                        }
                    }
                }
            },
        },
        created() {
            this.$parent.showSubMenu = 'GS';
            this.$parent.showActiveMenu = 'GS.GLCBA';
            // this.getGameList();
        },
        watch: {
            int_Page(newValue) {
                if (newValue > 0 && newValue <= this.int_TP) {
                    this.getGameList(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort, this.str_FV);
                }
            },
            getLanguage() {
                this.getGameList();
                this.getCategory();
            },
            searchAgent: function (newData, oldData) {
                if (newData != oldData) {
                    this.arr_GameList = [];
                    this.changedConfigs = [];
                    this.arr_GameListChild = [[]];
                    this.opened = [];
                }
            },
        },
    }
</script>

<style>
    .chkPadding {
        padding: 0.25rem !important;
    }

    .checkBoxTD {
        text-align: center;
        vertical-align: middle;
    }

    .checkBox15 {
        width: 15px;
        height: 15px;
        cursor: pointer;
    }

    .checkBox12 {
        width: 12px;
        height: 12px;
        cursor: pointer;
    }

    .width80 {
        width: 80px;
        max-width: 100px;
        min-width: 80px;
    }

    .childClass {
        background: #FFFFCC !important;
    }
</style>




// WEBPACK FOOTER //
// src/components/SideMenu/GameSettings/GameListConfigByAgent.vue